module.exports = __webpack_public_path__ + "img/scheme-ladder.6e8596a4.jpg";